import { Children, isValidElement } from 'react';
import { DialogProps } from '@mui/material';
import Modal from './Modal';
import DialogTitle from './DialogTitle';
import DialogActions from './DialogActions';
export default function Dialog({open,onClose,children,maxWidth='sm',disableEscapeKeyDown}:DialogProps) {
    const nodes=Children.toArray(children);
    const title=nodes.find(node=>isValidElement(node) && node.type===DialogTitle);
    const actions=nodes.find(node=>isValidElement(node) && node.type===DialogActions);
    return <Modal open={open} onClose={()=>{onClose?.({} as any,'escapeKeyDown');}} disableEscapeKeyDown={disableEscapeKeyDown}
        title={isValidElement(title) ? (title.props as any).children : undefined}
        footer={isValidElement(actions) ? (actions.props as any).children : undefined}
        size={maxWidth==='xl'||maxWidth==='lg' ? 'xl' : maxWidth==='md' ? 'lg' : maxWidth==='xs' ? 'sm' : undefined}>
        {nodes.filter(node=>node!==title && node!==actions)}
    </Modal>;
}
